import http from './public'
// 登陆
export const userLogin = (params) => {
  return http.fetchPost("/user/api/doLogin", params)
}
// 游客登录
export const visitorLogin = () => {
  return http.fetchPost("/user/api/doLogin", { loginName: 'visitor' })
}

// 退出登陆
export const loginOut = (params) => {
  return http.fetchGet('/member/loginOut', params)
}
// 判断后台登录是否在线
export const checkState = (params = {}) => {
  return http.fetchPost("/user/api/isLogin", params);
}
export const logout = (params = {}) => {
  return http.fetchPost("/user/api/logout", params);
}



// WEBPACK FOOTER //
// ./src/api/index.js